import { ChatWindowsContext } from "@/context/ChatWindowsContext";
import React from "react";

export default function useChatWindows() {
  return React.useContext(ChatWindowsContext);
}
